import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { ButtonComponent, IconComponent } from '@mode/capra';
import { MatLegacyMenuModule } from '@angular/material/legacy-menu';

export interface RadioDropdownData {
  type: string;
  name: string;
}

@Component({
  standalone: true,
  imports: [CommonModule, IconComponent, MatLegacyMenuModule, ButtonComponent],
  selector: 'mode-radio-dropdown',
  templateUrl: './radio-dropdown.component.html',
  styleUrls: ['./radio-dropdown.component.scss'],
})
export class RadioDropdownComponent implements OnInit {
  @Input() dropdownData: RadioDropdownData[] = [];
  @Input() placeholder!: string;
  @Input() selectedValue!: string;
  @Output() dropdownChange = new EventEmitter<string>();
  displayValue!: string;

  ngOnInit(): void {
    this.displayValue = this.dropdownData.find((item) => item.type === this.selectedValue)?.name || this.placeholder;
  }

  onSelectionChange(value: RadioDropdownData): void {
    this.displayValue = value.name;
    this.dropdownChange.emit(value.type);
  }
}
